import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetNotes } from '../../../../state';

const NotesEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetNotes({ notes: event.target.value }));
  };

  return (
    <TextField
      label="Additional Notes"
      size="small"
      fullWidth
      multiline
      rows={3}
      value={currentAsset?.notes || ''}
      onChange={handleChange}
      InputProps={{
        sx: {
          alignItems: 'flex-start',
          '& .MuiInputBase-input': {
            paddingTop: '8px',
          }
        }
      }}
    />
  );
};

export default NotesEdit;
